import Dropzone from "react-dropzone"
import { Tooltip } from "react-tooltip"

import { ILogin } from "./login.types"
import logo from './../../styles/images/logo.png'
import imgEmpty from './../../styles/images/empty.svg'

import Flex from "../../components/ui/flex/flex"
import Input from "../../components/ui/input/input"
import Empty from "../../components/ui/empty/empty"
import Button from "../../components/ui/button/button"
import Divider from "../../components/ui/divider/divider"
import { TableBody, TableContainer, TableRow } from "../../components/ui/table/table"

import { getDefiningFileUnit } from "../../services/func.service"
import { IconContracts, IconDelete, IconPhone, IconSelectData, IconUser } from "../../styles/images/icons"
import SelectDictionaryContainer from "../../components/smart/selectDictionary/selectDictionary.container"
import { ModalConfirm } from "../../components/dumb/modal.confirm"
import ModalSMSContainer from "../../components/smart/modalSMS/modalSMS.container"


/** Авторизация пользователя */
const Login = ({ 
    isLoading, txtClientName, txtClientPhone, txtCourseID, txtCourseName, txtApplicationNumber,
    txtVolumeHours, txtProgramName, filesState, modalDict, modalConfirm, modalSms, 
    handleButtonClickLogin, txtPhoneChange, fileUploader, deleteFileByName, handlerOpenModalDict, handlerOpenModalConfirm, handleButtonClickTelegram
}: ILogin) => {
    return <>
        <ModalConfirm {...modalConfirm.value} />
        <ModalSMSContainer {...modalSms.value} />
        <SelectDictionaryContainer {...modalDict.value} />

        <Flex height="100%" alignItems="center" className="login_wrapper">
            <Flex gap="10px" className="auth_container">
                <Flex gap="10px" direction="row" alignItems="center" justifyContent="center">
                    <img src={logo} alt="Лого университета" />
                    <h4 className="logo_style">Современная Академия<br />Подача документов</h4>
                </Flex>

                {/* <div style={{ padding: '0 10px' }}>
                    <Button onClick={handleButtonClickTelegram}>Отправить менеджеру в Telegram</Button>
                </div> */}

                <form style={{ padding: '0 10px' }}>
                    <Flex gap="10px">
                        <Flex>
                            <h5 style={{ paddingLeft: '6px' }}>1. Как к Вам обращаться</h5>
                            <Input size="md"
                                placeholder="Ваше имя"
                                prefix={<IconUser width={18} height={18} opacity={.6} />}
                                value={txtClientName.value} onChange={(e) => txtClientName.setValue(e.target.value)}
                            />
                        </Flex>

                        <Flex>
                            <h5 style={{ paddingLeft: '6px' }}>2. Номер Вашего телефона</h5>
                            <Input size="md"
                                placeholder="Ваш номер телефона"
                                prefix={<IconPhone width={18} height={18} opacity={.6} />}
                                value={txtClientPhone.value} onChange={(e) => txtPhoneChange(e.target.value)}
                            />
                        </Flex>

                        <Flex>
                            <h5 style={{ paddingLeft: '6px' }}>3. Выберите курс</h5>
                            <Input size="md" isReadOnly
                                placeholder="Выберите курс" paddingRight={3}
                                prefix={<IconContracts width={18} height={18} opacity={.6} />}
                                suffix={<Button id='toolTipSelect' size='sm' variant='icon' onClick={() => handlerOpenModalDict(true, 'courses')}><IconSelectData /></Button>}
                                value={txtCourseName.value} onChange={(e) => txtCourseName.setValue(e.target.value)}
                            />
                        </Flex>

                        <Flex>
                            <h5 style={{ paddingLeft: '6px' }}>4. Выберите программу</h5>
                            <Input size="md" isReadOnly
                                isDisabled={!txtCourseName.value}
                                placeholder="Выберите программу" paddingRight={3}
                                prefix={<IconContracts width={18} height={18} opacity={.6} />}
                                suffix={<Button id='toolTipSelect' size='sm' variant='icon' onClick={() => handlerOpenModalDict(true, 'programs', txtCourseID.value)}><IconSelectData /></Button>}
                                value={txtVolumeHours.value} onChange={(e) => txtVolumeHours.setValue(e.target.value)}
                            />
                        </Flex>

                        <Divider margin="8px" />

                        <Flex gap="10px">
                            <span>У вас есть выбор: либо отправить документы напрямую менеджеру через Telegram, нажав кнопку ниже 👇<br/><br/>(Внимание! После того как откроется приложение Telegram, в поле <b style={{color: '#000'}}>«Написать сообщение...»</b> сгенерируется информация для менеджера. Просьба сначала отправить это сообщение, а заем необходимо отправить менеджеру, <b>фото или файлы с вашими документами</b>, для зачисления на курс.)</span>
                            <Button onClick={handleButtonClickTelegram} isDisabled={!txtClientName.value || !txtClientPhone.value || !txtCourseName.value || !txtProgramName.value}>Отправить менеджеру в Telegram</Button>
                            <Divider margin="8px" />
                            <span>Либо загрузить файлы методом перетаскивания, или нажать на кнопку <b style={{color: '#000'}}>«ДОБАВИТЬ»</b> в поле ниже 👇</span>
                        </Flex>

                        {/* <TableContainer className="program_container">
                            <Divider prefix={<p style={{ fontWeight: '600', marginLeft: '4px' }}>ПРОГРАММА</p>} suffix={
                                <Button size="sm" padding='0 10px' isDisabled={!txtCourseName.value} onClick={() => handlerOpenModalDict(true, 'programs', txtCourseID.value)}>
                                    {txtVolumeHours.value ? 'Изменить' : 'Выбрать'}
                                </Button>}
                            />

                            <TableBody overflowY="hidden">
                                {!txtProgramName.value
                                    ? <Empty image={imgEmpty} size='50px' />
                                    : <TableRow classGridTemplateColumns="files_grid_columns">
                                        <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                            <p>{txtVolumeHours.value}</p>
                                            <p style={{ opacity: '.7' }}>{txtProgramName.value}</p>
                                        </div>
                                    </TableRow>
                                }
                            </TableBody>
                        </TableContainer> */}

                        <Dropzone onDropAccepted={(files) => fileUploader(files)} multiple={true}>
                            {({ getRootProps, getInputProps, isDragAccept, isDragActive }) => (
                                <section {...getRootProps({ className: isDragAccept ? `dropZone` : ``, onClick: event => event.stopPropagation() })}>
                                    <input {...getInputProps()} />

                                    <TableContainer className="files_container">
                                        <Divider prefix={<div style={{ fontWeight: '600', marginLeft: '4px', textWrap: 'nowrap' }}>ФАЙЛЫ ({filesState.value.length})</div>} suffix={
                                            <Dropzone onDropAccepted={(files) => fileUploader(files)}>
                                                {({ getRootProps, getInputProps }) => (
                                                    <div {...getRootProps()}>
                                                        <input {...getInputProps()} />
                                                        <Button size="sm" padding='0 10px'>ДОБАВИТЬ</Button>
                                                    </div>
                                                )}
                                            </Dropzone>
                                        } />

                                        <TableBody>
                                            {filesState.value.length === 0
                                                ? <Empty image={imgEmpty} size='50px' />
                                                : filesState.value.map((item, index) => (
                                                    <TableRow key={index + 1} indexNumber={<span>{index + 1}</span>} indexNumberWidth="30px" classGridTemplateColumns="files_grid_columns">
                                                        <div>
                                                            <p>{item.name}</p>
                                                            <p style={{ opacity: '.7' }}>Размер файла: {getDefiningFileUnit(item.size)}</p>
                                                        </div>

                                                        <nav>
                                                            <Button id='toolTipDelete' variant="icon" size="xs" onClick={() => deleteFileByName(item.name)}><IconDelete /></Button>
                                                        </nav>
                                                    </TableRow>
                                                ))
                                            }
                                        </TableBody>

                                        <Divider margin="8px" />
                                        <h5>Требования к файлам:</h5>
                                        <ul>
                                            <li>1. Максимальное количество файлов, не более 10;</li>
                                            <li>2. Максимальный размер одного файла, не более 10 мегабайт;</li>
                                            <li>3. Разрешены файлы изображений, pdf файлы, файлы офиса и текстовые файлы;</li>
                                        </ul>
                                        <Divider margin="8px" />
                                        <h5>Перечень документов:</h5>
                                        <ul>
                                            <li>1. Скан-копия паспорта с пропиской;</li>
                                            <li>2. Скан-копия СНИЛС;</li>
                                            <li>3. Скан-копия диплома о высшем или среднем профессиональном образовании, без приложения;</li>
                                            <li>4. Реквизиты юридического лица (если обучение будет производиться от организации);</li>
                                        </ul>
                                        {/* <Grid gap="6px" gridTemplate="columns" gridTemplateColumns="1fr 1fr">
                                            <Button variant="primaryDark" size="sm" isLoading={isLoading} onClick={() => handlerOpenModalConfirm(true, 'Требования к файлам...', '1) Максимальное количество файлов не более 10;<br/><br/>2) Максимальный размер одного файла не более 10 мегабайт;<br/><br/>3) Разрешены файлы изображений, pdf файлы, файлы офиса и текстовые файлы.')}>ПРАВИЛА</Button>
                                            <Button variant="primaryDark" size="sm" isLoading={isLoading} onClick={() => handlerOpenModalConfirm(true, 'Перечень документов...', '1) Скан-копии паспорта с пропиской;<br/><br/>2) Скан-копии СНИЛСа;<br/><br/>3) Скан-копии диплома о высшем или среднем профессиональном образовании без приложения;<br/><br/>4) Реквизиты юр. лица (если обучение будет производиться от организации);')}>ПЕРЕЧЕНЬ</Button>
                                        </Grid> */}
                                    </TableContainer>
                                </section>
                            )}
                        </Dropzone>

                        <p className="consent_processing">Нажимая на кнопку, я соглашаюсь на <a href="https://modskill.ru/docs/политика_обработки_персональных_данных.pdf" target='_blank' rel="noreferrer">обработку персональных данных</a></p>
                        <Button isLoading={isLoading} onClick={handleButtonClickLogin}>ОТПРАВИТЬ</Button>
                    </Flex>
                </form>
            </Flex>

            <Tooltip anchorSelect="#toolTipSelect" place="left" content='Выбрать' style={{ borderRadius: '10px' }} border='2px solid #f34e2e' />
            <Tooltip anchorSelect="#toolTipDelete" place="left" content='Удалить' style={{ borderRadius: '10px' }} border='2px solid #f34e2e' />
        </Flex>
    </>
}

export default Login